import { Injectable } 					from '@angular/core';
import { Router, CanActivate,  
		 ActivatedRouteSnapshot,
		 CanActivateChild } 			from '@angular/router';
import { UserService, RolesService } 	from '../_services/index';

@Injectable()
export class LoggedInGuard implements CanActivate, CanActivateChild {
  constructor(public router: Router, private roles: RolesService, private user: UserService) {}

  canActivate(route: ActivatedRouteSnapshot) {
  	if(this.user.isLoggedIn()) {
  		let role = route.data["roles"] as Array<string>;
	  	role = role ? role : route.children[0]["data"]["roles"];
	    return (this.roles.canGoHere(role));
  	} else {
      this.router.navigate(['users/login']);
    }
  	
  	return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot) {
  	if(this.user.isLoggedIn()) {
  		let role = route.data["roles"] as Array<string>;
	  	role = role ? role : route.children[0]["data"]["roles"];
	    return (this.roles.canGoHere(role));
  	} else {
      this.router.navigate(['users/login']);
    }
  	
  	return false;
  }
}


// WEBPACK FOOTER //
// ./src/app/_guards/logged-in.guard.ts